import axios from 'axios';
import { API_CONFIG } from '../config/api';

const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout || 30000,
  headers: API_CONFIG.headers,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const carePlanService = {
  listByPatient: async (patientId) => {
    const response = await api.get(`/care-plans/patient/${patientId}`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/care-plans', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.patch(`/care-plans/${id}`, data);
    return response.data;
  },
};

export default carePlanService;
